export const checkSize = (size) => window.matchMedia(`only screen and (max-width: ${size}px)`).matches;

export const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

export const pluralize = (num, str) =>
  num == 1 ? `${num} ${str}` : `${num} ${str}s`;

export const listFormatter = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});
